import { render, staticRenderFns } from "./QBRCategoryMaintain.vue?vue&type=template&id=f0190b42&scoped=true"
import script from "./QBRCategoryMaintain.vue?vue&type=script&lang=js"
export * from "./QBRCategoryMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0190b42",
  null
  
)

export default component.exports